// extracted by mini-css-extract-plugin
export default {"main":"HomePage_main__jA0dy"};